var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4944_167456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4944_167456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29998 10.1359L10.8359 6.59997L10.1231 5.88717L7.29998 8.71024L5.88717 7.29742L5.17437 8.01022L7.29998 10.1359ZM7.99998 14.3205C6.55811 13.9273 5.36431 13.0786 4.41858 11.7743C3.47286 10.47 3 9.01193 3 7.39997V3.56409L7.99998 1.69231L13 3.56409V7.39997C13 9.01193 12.5271 10.47 11.5814 11.7743C10.6357 13.0786 9.44186 13.9273 7.99998 14.3205ZM7.99998 13.2666C9.15554 12.9 10.1111 12.1666 10.8667 11.0666C11.6222 9.96664 12 8.74442 12 7.39997V4.24997L7.99998 2.75639L3.99998 4.24997V7.39997C3.99998 8.74442 4.37776 9.96664 5.13332 11.0666C5.88887 12.1666 6.84443 12.9 7.99998 13.2666Z",
    fill: "#21438B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcement_icon.d08a6e7c78c392e17bd237819f28e5c9.svg";
export { ForwardRef as ReactComponent };